import React, { useContext } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import CheckToggle from 'components/CheckToggle';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';
import CurrentProfileContext from '../../providers/CurrentProfile/CurrentProfile.context';

import './MessagingPreferences.styles.scss';

type MessagingPreferencesProps = {
  className?: string;
};

const MessagingPreferences: React.FC<MessagingPreferencesProps> = (props) => {
  const { className } = props;

  const { currentUser, updatePreferences } = useContext(CurrentUserContext);
  const { isMyProfile } = useContext(CurrentProfileContext);

  const { t } = useTranslation();

  const classes = classNames('messaging-preferences', className);

  if (!isMyProfile) return null;

  return (
    <div className={classes}>
      <p className="messaging-preferences__title">{t('messaging')}</p>

      <div className="messaging-preferences__toggle">
        <CheckToggle
          checked={!currentUser?.hideReplySuggestions}
          onChange={({ target: { checked } }) =>
            updatePreferences({ hideReplySuggestions: !checked })
          }
        />
        <p>{t('showReplySuggestionsInMessages')}</p>
      </div>
    </div>
  );
};

export default MessagingPreferences;
